import { NgModule, Optional } from '@angular/core';
import { InlineEditComponent } from 'app/components/inline-edit/inline-edit.component';
import { InlineComponent } from 'app/utils/inline/inline.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EllipsisComponent } from 'app/utils/ellipsis.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I360ValidationModule } from 'app/utils/validator/validation.module';
import { StatisticsService } from 'app/services/statistics';

@NgModule({
    declarations: [
        InlineComponent,
        InlineEditComponent,
        EllipsisComponent
    ],
    exports: [
        InlineComponent,
        InlineEditComponent,
        EllipsisComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        I360ValidationModule,
    ],
    providers: [
    ],
})
export class I360InlineEditModule {
    constructor(
        @Optional() statistics: StatisticsService,
    ) {}
}
